export default {
  delivery_tracking: "تتبع التوصيل",
  order: "طلب",
  live_tracking: "تتبع مباشر",

  driver: "السائق",
  vehicle: "المركبة",
  eta: "وقت الوصول",
  status: "الحالة",
  arriving_in: "سيصل خلال",
  distance: "المسافة",
  destination: "الوجهة",

  open_navigation: "فتح الملاحة",
  last_updated: "آخر تحديث",

  arriving: "وصل",
  mins: "دقيقة",

  delivery_completed_success: "تم إكمال التوصيل بنجاح",

  status_assigned: "تم تعيين السائق",
  status_on_way: "في الطريق",
  status_delivered: "تم التسليم"
};